import styled from 'styled-components';

export const CheckboxV2 = styled.input`
  margin-right: 4px;
  cursor: pointer;
  width: 20px;
  height: 20px;
  accent-color: #00D95F;
  border-radius: 4px;
`;